import Instrumento from "@/models/Instrumento";
import Profissional from "../models/Profissional";

export default class MedicaoEspessura {
  constructor() {
    this.numero = "";
    this.data = new Date();
    this.material = "Aço Carbono";
    this.tecnica = "Pulso Eco";
    this.transdutor = "TM-510";
    this.superficie = "Escovada / Limpa";
    this.temperatura = this.randomNumber() + " °C";
    this.velocidade = "5.920 m/s";
    this.acoplante = "Gel";
    this.procedimento = "";
    this.criterio = "Item 13.1 e 13.2";
    this.itens = this.getDefaultItens();
    this.observacao = "Aparelho de Medição é Micro-Processado - Todas as medições estão em milimetros.";
    this.medidor = new Instrumento();
    this.bloco = new Instrumento();
    this.inspetor = new Profissional();
  }

  update(me) {
    this.numero = me.numero;
    this.data = me.data;
    this.material = me.material;
    this.tecnica = me.tecnica;
    this.transdutor = me.transdutor;
    this.superficie = me.superficie;
    this.temperatura = me.temperatura;
    this.procedimento = me.procedimento;
    this.criterio = me.criterio;
    this.itens = me.itens;
    this.observacao = me.observacao;
    this.medidor = me.medidor;
    this.bloco = me.bloco;
    this.inspetor = me.inspetor;
  }

  randomNumber() {
    return parseFloat(Math.random() * (36 - 20) + 20).toFixed(1);
  }

  getDefaultItens() {
    let list = [];
    for (let index = 0; index < 6; index++) {
      list.push({
        a: "0.0",
        b: "0.0",
        c: "0.0",
        d: "0.0",
      });
    }
    return list;
  }
}
